@if (isLoading) {
  <div class="loading-indicator">
    <mat-progress-spinner
      mode="indeterminate"
      color="accent"
    ></mat-progress-spinner>
  </div>
}
@if (!error) {
  <div class="canvas-container">
    <div>
      <div>
        <div style="display: block" [style.height.px]="chartHeight">
          <canvas
            baseChart
            [data]="doughnutChartData"
            [labels]="doughnutChartLabels"
            [type]="doughnutChartType"
            [options]="chartOptions"
          ></canvas>
        </div>
      </div>
    </div>
  </div>
}
@if (error) {
  <p class="chartErrorText">{{ error }}</p>
}
